import { CurrencyConversionStatus } from '@40seas/entities/currency-exchange';
import { EnumColor } from '@40seas/frontend/common/providers';

export const currencyConversionStatusMapping = {
    [CurrencyConversionStatus.Pending]: 'info',
    [CurrencyConversionStatus.Scheduled]: 'info',
    [CurrencyConversionStatus.Overdue]: 'error',
    [CurrencyConversionStatus.Settled]: 'success',
    [CurrencyConversionStatus.Cancelled]: 'error',
    [CurrencyConversionStatus.Blocked]: 'error',
    [CurrencyConversionStatus.InProgress]: 'warning',
} as { [key in CurrencyConversionStatus]: EnumColor };
